const dateFormatter = new Intl.DateTimeFormat('en-US', {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    timeZone: 'UTC'
})

const shortDateFormatter = new Intl.DateTimeFormat('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    timeZone: 'UTC'
})

export const formatDate = (iso: string): string => dateFormatter.format(new Date(iso))

export const formatShortDate = (iso: string): string => shortDateFormatter.format(new Date(iso))
